import React from 'react';

const LogoImage = ({ type = 'white', style = {} }) => {
  const logoPath = type === 'white'
    ? '/images/navigator-logo-white.png'
    : '/images/navigator-logo-transparent.png';

  const defaultStyle = {
    height: '30px',
    width: 'auto',
    display: 'block',
    ...style
  };

  return (
    <img 
      src={logoPath}
      alt="Business Resilience Navigator Logo"
      style={defaultStyle}
      onError={(e) => {
        console.error('Logo failed to load:', e.target.src);
        e.target.style.display = 'none';
      }}
    />
  );
};

export default LogoImage;
